
exports.conditions = {
  burn: {
    code: 'burn',
    display: 'Burn',
    system: 'bcm',
  },
  stroke: {
    code: 'stroke',
    display: 'Stroke',
    system: 'bcm'
  },
};